import { useEffect, useMemo, useState } from 'react'

import { useCurrentUser } from '@/api/auth/queries/useCurrentUser'
import type { LoggedUser } from '@/api/auth/types/LoggedUser'
import { Button } from '@/Components/ui/button'
import { Card, CardContent } from '@/Components/ui/card'
import { Label } from '@/Components/ui/label'
import { Spinner } from '@/Components/ui/spinner'

import ChangePasswordDialog from './ChangePasswordDialog'

type EditableProfile = {
  name: string
  family_name: string
  email: string
  phone_number: string
}

const toEditable = (user?: LoggedUser): EditableProfile => {
  return {
    name: user?.UserAttributes?.name ?? '',
    family_name: user?.UserAttributes?.family_name ?? '',
    email: user?.UserAttributes?.email ?? '',
    phone_number: user?.UserAttributes?.phone_number ?? '',
  }
}

export default function ProfileEditPage() {
  const { data: currentUser } = useCurrentUser()
  // const { mutate: updateUser, isPending: isUpdatingUser, isSuccess: isUpdateUserSuccess } = useUpdateUser()

  const initial = useMemo(() => toEditable(currentUser), [currentUser])
  const [form, setForm] = useState<EditableProfile>(initial)
  const [isPasswordDialogOpen, setIsPasswordDialogOpen] = useState(false)

  useEffect(() => {
    setForm(initial)
  }, [initial])

  // const handleChange = (field: keyof EditableProfile, value: string) => {
  //   setForm(prev => ({ ...prev, [field]: value }))
  // }

  // const handleSubmit = () => {
  //   const payload = {
  //     name: form.name,
  //     family_name: form.family_name,
  //     email: form.email,
  //     phone_number: form.phone_number,
  //   }
  //   updateUser(payload)
  // }
  return (
    <>
      <Card className='bg-white'>
        {currentUser ? (
          <CardContent className='space-y-6'>
            <div className='grid grid-cols-1 gap-4 md:grid-cols-2'>
              <div className='space-y-2'>
                <Label htmlFor='name'>שם פרטי</Label>
                <p className='text-text-primary text-sm leading-5 font-medium'>{form.name}</p>
              </div>
              <div className='space-y-2'>
                <Label htmlFor='family_name'>שם משפחה</Label>
                <p className='text-text-primary text-sm leading-5 font-medium'>{form.family_name}</p>
              </div>
              <div className='space-y-2'>
                <Label htmlFor='email'>אימייל</Label>
                <p className='text-text-primary text-sm leading-5 font-medium'>{form.email}</p>
              </div>
              <div className='space-y-2'>
                <Label htmlFor='phone_number'>טלפון נייד</Label>
                <p dir='ltr' className='text-text-primary text-right text-sm leading-5 font-medium'>
                  {form.phone_number.replace('+972', '')}
                </p>
              </div>
            </div>
            <div className='flex items-center'>
              <Button variant='link' onClick={() => setIsPasswordDialogOpen(true)}>
                שינוי סיסמה
              </Button>
            </div>
            {/* <div className='flex items-center justify-end gap-3'>
            <Button variant='secondary' onClick={() => setForm(initial)} disabled={isUpdatingUser}>
              בטל
            </Button>
            <Button onClick={handleSubmit} disabled={isUpdatingUser}>
              {isUpdatingUser ? 'שומר…' : isUpdateUserSuccess ? 'נשמר' : 'שמירה'}
            </Button>
          </div> */}
          </CardContent>
        ) : (
          <Spinner className='mx-auto size-10' />
        )}
      </Card>

      <ChangePasswordDialog isOpen={isPasswordDialogOpen} onOpenChange={setIsPasswordDialogOpen} />
    </>
  )
}
